import { AudioItemColor } from "./AudioItem";

export const config = [
  {
    text: "We're off under the lights here for this semi-final clash...",
    audioUrl: "https://eleven-public-cdn.elevenlabs.io/payloadcms/lbbkvn8mglr-new football 2a.wav",
    imageUrl: "/assets/images/voices/orbs/callum.webp",
    textColor: AudioItemColor.BLUE,
  },
  {
    text: "Oh, wow. Is this... is this me? Am I actually... talking?",
    audioUrl: "https://eleven-public-cdn.elevenlabs.io/payloadcms/yzkwj6h0olb-EXISTENTIAL FINAL.mp3",
    imageUrl: "/assets/images/voices/orbs/jessica.webp",
    textColor: AudioItemColor.ORANGE,
  },
  {
    text: "I couldn't sleep that night. The air was too still, and the moonlight kept sliding through the blinds...",
    audioUrl: "https://eleven-public-cdn.elevenlabs.io/payloadcms/37k0r15m2aq-SLEEP FINAL.mp3",
    imageUrl: "/assets/images/voices/orbs/liam.webp",
    textColor: AudioItemColor.PINK,
  },
  {
    text: "Arr, the open ocean. Smell that, lads? That’s the scent of freedom… and just a hint of mutiny.",
    audioUrl: "https://eleven-public-cdn.elevenlabs.io/payloadcms/5kla0ezckp3-PIRATE FINAL.mp3",
    imageUrl: "/assets/images/voices/orbs/laura.webp",
    textColor: AudioItemColor.PINK,
  },
  {
    text: "Hey Chris… Knock knock. \n[chuckles] I'm not doing this AGAIN!",
    audioUrl: "https://eleven-public-cdn.elevenlabs.io/payloadcms/acmrrbz64tu-BADJOKES FINAL.mp3",
    imageUrl: "/assets/images/voices/orbs/julian.webp",
    textColor: AudioItemColor.BLUE,
  },
  {
    text: "Okay, so like I finally beat level 42 of that game I said I’d quit like... a month ago.",
    audioUrl: "https://eleven-public-cdn.elevenlabs.io/payloadcms/eycydkc4q1-bunny1.wav",
    imageUrl: "/assets/images/voices/orbs/hmida.webp",
    textColor: AudioItemColor.GREEN,
  },
  {
    text: "Oh my God. [laughs] You guys, like no joke, I just tried this TTS thing and it was, like, weirdly emotional.",
    audioUrl: "https://eleven-public-cdn.elevenlabs.io/payloadcms/amhkzz9pw0b-Marissa - capricorn.wav",
    imageUrl: "/assets/images/voices/orbs/keren.webp",
    textColor: AudioItemColor.BLUE,
  },
  {
    text: "[laughs hard] Good morning, folks! It’s 7:02 on this bright Thursday, and you're watching Daybreak Now! I'm Alex Rivera...",
    audioUrl:
      "https://eleven-public-cdn.eleven2.dev/payloadcms/af5rll98bkf-ElevenLabs_2025-05-29T09_12_52_Charlie_pre_sp100_s50_sb75.mp3",
    imageUrl: "/assets/images/voices/orbs/kozy.webp",
    textColor: AudioItemColor.BLUE,
  },
];
